module.exports = __webpack_public_path__ + "static/media/19__CALCINHA_DRAPEADA_LISA_02.b8147ad1.jpg";